import { AppState, WidgetPageGlasgowAppState } from '../../initialStateRegistration';

const getWidgetPage = (state: AppState) => (state as WidgetPageGlasgowAppState).template;

export const getMetadataDescription = (state: AppState) => getWidgetPage(state).metadataDescription;

export const getMetadataTitle = (state: AppState) => getWidgetPage(state).metadataTitle;

export const getMetadataImage = (state: AppState) => getWidgetPage(state).metadataImage;

export const getSocialSharingDescription = (state: AppState) => getWidgetPage(state).socialSharingDescription;

export const getSocialSharingTitle = (state: AppState) => getWidgetPage(state).socialSharingTitle;

export const getSocialSharingImage = (state: AppState) => getWidgetPage(state).socialSharingImage;

export const getWidgetHTML = (state: AppState) => getWidgetPage(state).widgetHTML;

export const getOutbrainWidgetID = (state: AppState) => getWidgetPage(state).outbrainWidgetID;

export const getTitle = (state: AppState) => getWidgetPage(state).title;

export const getSubtitle = (state: AppState) => getWidgetPage(state).subtitle;

export const getShouldSetMinHeightForTopAd = (state: AppState) => getWidgetPage(state).shouldSetMinHeightForTopAd;
